import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  catchError,
  delay,
  exhaustMap,
  filter,
  map,
  mapTo,
  switchMap,
  switchMapTo,
  takeUntil,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { EMPTY, of, Subject, Subscription, timer } from 'rxjs';
import { PaymentService } from '../../services/payment.service';
import { SharedService } from '../../shared/shared.service';
import { PrintService } from '../../shared/print.service';
import { FormService } from '../../shared/form.service';
import { ProposalService } from '../../shared/proposal.service';
import { LocalStorageService } from 'ngx-localstorage';
import { environment } from '../../../environments/environment';
import { PrintDocumentService } from 'src/app/services/print.service';
import { HttpClient } from '@angular/common/http';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { KpiEnum } from 'src/app/interfaces/kpi.enum';
import { TrackService } from 'src/app/services/track.service';
import { SignPolicyModalComponent } from '../evrotrust/sign-policy-modal/sign-policy-modal.component';
import { SocketService } from 'src/app/shared/soket.service';
import { OfferService } from 'src/app/shared/offer.service';
import { LoadedFromCPService } from 'src/app/shared/loaded-from-customer-portal.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: [
    './error.component.scss',
    '../Step 2/offer/offer.component.scss',
    '../Step 1/details1/details1.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ErrorComponent implements OnInit, OnDestroy {
  @ViewChild('submitFormPayButton') boricaFormSubmitButton: ElementRef;

  Form: FormGroup;
  showMobile;
  data: any = {};
  boricaProperties;
  isSoftDecline: boolean = false;
  boricaUrl: string;

  policyId: string;

  premiumData;

  calculatedPremiums;

  selected = false;

  paymentClicks$ = new Subject<any>();
  private onDestroy$ = new Subject<void>();
  private sendErrorClicks$ = new Subject<void>();
  digitalSignEvrotrsutRef: NxModalRef<SignPolicyModalComponent>;

  phoneCodes = [];
  deactivateMask = false;
  phoneMask = '00 000 0000';
  phoneSeparator = [' '];
  parentForm: any;
  phonePattern: string;

  constructor(
    public dialogService: NxDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private formService: FormService,
    private chRef: ChangeDetectorRef,
    private printDocumentService: PrintDocumentService,
    public proposalService: ProposalService,
    public sharedService: SharedService,
    public http: HttpClient,
    private printService: PrintService,
    private paymentService: PaymentService,
    public trackService: TrackService,
    public offerService: OfferService,
    private storage: LocalStorageService,
    private socketService: SocketService,
    public formBuilder: FormBuilder,
    public loadedFromCPService: LoadedFromCPService
  ) {
    this.Form = this.formBuilder.group({
      // mobilePhone: ['', [Validators.required, Validators.pattern('[+][3]{1}[5]{1}[9]{1}[1-9]{1}[0-9]{8}$')]],
      mobileCode: [null, [Validators.required]],
      mobilePhone: ['', [Validators.required]],
    });
    if (this.route.snapshot?.data) {
      Object.assign(this.data, this.route.snapshot?.data);
    }
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        Object.assign(this.data, this.route.snapshot.data);
        if (this.data.image) this.updateControl(this.data);
      });
  }

  updateControl(snapshotData) {
    // snapshotData.newCar =>
    setTimeout(() => {
      this.sharedService.setSanpshotData(snapshotData);
      this.chRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();

    if (this.subscription3) {
      this.subscription3.unsubscribe();
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  get mobileCode() {
    return this.Form.get('mobileCode');
  }
  get mobilePhone() {
    return this.Form.get('mobilePhone')
  }

  ngOnInit(): void {
    this.parentForm = this.formService.currentForm;

    // this.sharedService.getPhoneCodes().subscribe((res) => {
    //   this.phoneCodes = res.map(function (el: any) {
    //     return el.value;
    //   });
    // });
    // if (this.phoneCodes[0]) {
    //   this.Form.get('mobileCode').setValue('+' + this.phoneCodes[0].value);
    // }

    // this.Form.get('mobileCode').valueChanges.subscribe((mobileCode) => {
    //   if (mobileCode !== '+359') {
    //     this.deactivateMask = true;
    //     this.phonePattern = '[0-9]{0,15}';
    //     this.Form.get('mobileCode').updateValueAndValidity();
    //   } else {
    //     this.deactivateMask = false;
    //     this.phonePattern = '^((?!(0))[0-9]{9})$';
    //     this.Form.get('mobileCode').updateValueAndValidity();
    //   }

    // });
    
//разкоментирай за модал
    // if(this.data?.finish){
    //   this.dialogService.open(SignPolicyModalComponent, {
    //     showCloseIcon: true,
    //     maxHeight: '600px',
    //     position: { top: '50px' }
    //   });
    // }

    this.setButtonFlags();

    this.boricaUrl = environment.BORICA_URL;

    this.policyId = this.storage.get('data')?.sPlcNomer;

    if (this.proposalService.calculatedPremiums$) {
      this.proposalService.calculatedPremiums$.subscribe(
        (data) => (this.calculatedPremiums = data)
      );
    }

    this.sendErrorClicks$
      .pipe(
        switchMapTo(this.sharedService.errorState$),
        takeUntil(this.onDestroy$),
        map((payload) => {
          this.sharedService.loadingSpinner = true;
          payload = payload || {};
          payload.mobile = this.Form.get('mobilePhone').value;
          return payload;
        }),
        switchMap((payload) =>
          this.http.post('/api/v1/email/call-me-back', payload).pipe(
            catchError((error) => {
              this.sharedService.loadingSpinner = false;
              return of(true);
            })
          )
        )
      )
      .subscribe((_) => {
        this.sharedService.loadingSpinner = false;
        return this.router.navigate(['callAgent']);
      });

    this.route.queryParamMap
      .pipe(
        map((queryParamMap) => queryParamMap.get('softDecline')),
        filter((softDecline) => softDecline === 'true'),
        tap((_) => (this.isSoftDecline = true)),
        switchMapTo(timer(3000)),
        mapTo(this.storage.get('payload')),
        exhaustMap((data) =>
          this.paymentService.getBoricaPayload(data).pipe(
            map((properties) =>
              Object.getOwnPropertyNames(properties).reduce((acc, current) => {
                acc.push({ key: current, value: properties[current] });
                return acc;
              }, [])
            ),
            tap((properties) => (this.boricaProperties = properties)),
            delay(0),
            tap((_) => this.boricaFormSubmitButton.nativeElement.click()),
            catchError((error) => {
              this.router.navigate(['unsuccessfulPayment']);
              return EMPTY;
            })
          )
        )
      )
      .subscribe();

    this.sharedService.nextClicks
      .pipe(
        filter((_) => location.href.includes('/payment')),
        takeUntil(this.onDestroy$),
        map((_) => this.calculatedPremiums),
        map((calculatedPremiums) => {
          if (calculatedPremiums) {
            const data = this.formService.getMainForm().getRawValue();
            this.storage.set('data', data);
            this.storage.set('cp', this.loadedFromCPService._isCustomerPortal);
            this.storage.set('offerId', this.offerService.savedOfferId)
            this.proposalService.trackingFinalData(data).subscribe();
            const payload = {
              email: data.ownerData?.email,
              payment: {
                natId: data.ownerData?.egn,
                sumaLV: data.nsumm,
                sumEur: data.nsummCurr2,
                dueDate: data.insuranceStart,
                policyRef: data.sPlcNomer,
                contractId: data.sPlcNomer,
              },
            };

            this.storage.set('payload', payload);
            return payload;
          } else {
            return this.storage.get('payload');
          }
        }),
        exhaustMap((data) =>
          this.paymentService.getBoricaPayload(data).pipe(
            map((properties) =>
              Object.getOwnPropertyNames(properties).reduce((acc, current) => {
                acc.push({ key: current, value: properties[current] });
                return acc;
              }, [])
            ),
            tap((properties) => (this.boricaProperties = properties)),
            delay(0),
            tap((_) => this.boricaFormSubmitButton.nativeElement.click()),
            catchError((error) => {
              this.router.navigate(['unsuccessfulPayment']);
              return EMPTY;
            })
          )
        )
      )
      .subscribe();

  }

  subscription3: Subscription;
  printPolicy() {
    this.sharedService.loadingSpinner = true;
    const data = this.storage.get('data');
    const policyId = data?.sPlcNomer;
   
    this.subscription3 = this.printDocumentService
      .getPolicyDocument(policyId)
      // .pipe(
      //   catchError(error => EMPTY)
      // )
      .subscribe(
        (data) => {
          const byteCharacters = atob(data.bBlob_PDF);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const URLObject = URL.createObjectURL(blob);
          window.open(URLObject, '_blank');
          this.sharedService.loadingSpinner = false;
        },
        (err) => {
          if (err) {
            this.sharedService.loadingSpinner = false;
          }
        },
        () => {
          this.sharedService.loadingSpinner = false;
        }
      );
  }

  getBoricaProperties() {
    return this.boricaProperties;
  }

  sendError() {
    if (this.Form.valid) {
      this.sendErrorClicks$.next();
    }
  }

  handleClick(action, data?) {
    if (action == 'print' || action == 'new-print') {
      this.printService.printPolicy(data);
    }
  }

  // isPerson = null;
  isRegistered = null;
  eMail = '';
  policyNum = '';
  link1 = 'https://www.allianz.bg';
  link2 = '';
  // setButtonFlags() {
  //   let rawData0 = this.formService.currentForm.getRawValue();
  //   console.dir("main form:" + JSON.stringify(rawData0))
  // }
  globalRawData;
  subscription: Subscription;
  setButtonFlags() {
    this.offerService.deleteSavedOfferId()
    let rawData;
    rawData = this.storage.get('data');

    if (rawData === undefined || rawData === null) {
      rawData = this.formService.currentForm.getRawValue();
    }

    this.globalRawData = rawData;
    const egn = rawData.policyholderData.egn;
    this.eMail = rawData.policyholderData.email;
    this.policyNum = rawData.sPlcNomer;


    let payload = btoa(egn);
    console.log('payload is: ' +  payload);
    let isFromCP = this.storage.get('cp') ? this.storage.get('cp') : false;
    this.mobileCode.setValue(rawData.policyholderData.countryCode || rawData.firstCountryCode);
    this.mobilePhone.setValue(rawData.policyholderData.phoneNumber || rawData.phoneNumber)


    this.subscription = this.http
      .post('/api/v1/validate/customer' + '?nationalId=' + payload + '&fromCp=' + isFromCP , '')
      .subscribe((result: ResponseType) => {
        this.isRegistered = result.registered;
        this.link2 = result.customerPortalURL;
        this.storage.remove('cp')
      });
  }

  btnClick1() {
    window.open(this.link1, '_self');
  }

  btnClick2() {
    window.open(this.link2, '_self');
  }

  btnClick3() {
    window.open(this.link2, '_self');
  }

  PrintData() {
    console.dir(this.data);
  }

  //Final reg to cutomer portal popup
  @ViewChild('thankYouReg') thankYouReg: TemplateRef<any>;
  ThankYouTemplate: NxModalRef<any>;

  clickToMyAllianz() {
    const postReq =
      '/api/v1/auto-registration?policyNumber=' +
      this.policyNum +
      '&isEmailReceived=true';
    let tempDate = this.globalRawData.insuranceStart.slice(0, 10);
    this.globalRawData.insuranceStart = tempDate;
    let changedData = {...this.globalRawData};
    changedData.policyholderData.nationalId = changedData.policyholderData.egn;
    changedData.policyholderData.city = changedData.policyholderData.cityName;
    this.http
      .post(postReq, changedData)
      .pipe(
        catchError((_) => EMPTY),
        tap(() =>
          this.sharedService
            .sendKpiTrackingData(KpiEnum.NEW_PROFILE_AFTER_QB)
            .subscribe()
        )
      )
      .subscribe((_) => {
        this.dialogService.closeAll();
        this.ThankYouTemplate = this.dialogService.open(this.thankYouReg, {
          width: '736px',
          showCloseIcon: true,
        });
      });
  }

  clickToMyAllianzBadMail() {
    const postReq =
      '/api/v1/auto-registration?policyNumber=' +
      this.policyNum +
      '&isEmailReceived=false';
    let tempDate = this.globalRawData.insuranceStart.slice(0, 10);
    this.globalRawData.insuranceStart = tempDate;
    this.http.post(postReq, this.globalRawData).subscribe((_) => {
      this.dialogService.closeAll();
      this.ThankYouTemplate = this.dialogService.open(this.thankYouReg, {
        width: '736px',
        showCloseIcon: true,
      });
    });
  }

  openModal() {
    this.ThankYouTemplate = this.dialogService.open(this.thankYouReg, {
      width: '736px',
      showCloseIcon: true,
    });
  }

  closePopUp() {
    this.dialogService.closeAll();
  }

  openModalEvrotrust(){
      this.digitalSignEvrotrsutRef = this.dialogService.open(SignPolicyModalComponent, {
        width:'1120px',
        height: '493px',
        maxWidth: '1120px',
        position: { top: '120px' }
      });
    
  }
}

interface ResponseType {
  customerPortalURL: string;
  registered: boolean;
}
